module.exports = __webpack_public_path__ + "static/img/Footprints.a6c64c57.png";